interface Props {
  className: string;
  imageSource: string | null;
}
export function Thumbnail({ className, imageSource }: Props) {
  return <div className={className} style={{ backgroundImage: imageSource ? `url(${imageSource})` : "" }}></div>;
}
